import React, { Fragment } from "react"
import PropTypes from "prop-types"
import { ThemeProvider } from "emotion-theming"

import { Dropdown } from "ui"
import WithApps from "data/wrappers/WithApps"
import SideBarItem, { SidebarLabel } from "./SideBarItem"

import stackerTheme from "ui/styleHelpers/stackerTheme"

const darkStacker = {
    ...stackerTheme,
    fontColor: "#bb9c44",
    fontWeight: 600,
    elementHighlightColor: "#f7de99",
    inputBackgroundColor: "#ffd766",
    outlineColor: "#ffd766",
}

class AppSwitcher extends React.Component {
    render() {
        return (
            <ThemeProvider theme={darkStacker}>
                <WithApps objectId={this.props.objectId}>
                    {({ apps, selectApp, selectedApp }) => {
                        return [apps].map(app => {
                            //     return (
                            //         <Fragment>
                            //             <SidebarLabel>Apps</SidebarLabel>
                            //             <SideBarItem
                            //                 icon="page"
                            //                 label="Pages"
                            //                 url={"apps/" + app._sid + "/pages"}
                            //             />
                            //             <SideBarItem
                            //                 icon="menu"
                            //                 label="Menus"
                            //                 url={"apps/" + app._sid + "/menus"}
                            //             />
                            //             <SideBarItem
                            //                 label="Theme"
                            //                 icon="palette"
                            //                 url={"apps/" + app._sid + "/theme"}
                            //             />
                            //         </Fragment>
                            //     )
                            // })
                            return (
                                <Dropdown
                                    style={{ width: 300 }}
                                    onChange={selectApp}
                                    placeholder="Select app"
                                    clearable={false}
                                    options={apppsToOptions(apps || [])}
                                    value={selectedApp._sid}
                                />
                            )
                        })
                    }}
                </WithApps>
            </ThemeProvider>
        )
    }
}

const apppsToOptions = apps => {
    return apps.map(record => ({
        label: record.name,
        value: record._sid,
    }))
}

AppSwitcher.propTypes = {
    objectId: PropTypes.string,
}

export default AppSwitcher



// WEBPACK FOOTER //
// ./src/features/studio/components/AppSwitcher.js